import { render, staticRenderFns } from "./BillingTypeTable.vue?vue&type=template&id=548066d6&"
import script from "./BillingTypeTable.vue?vue&type=script&lang=js&"
export * from "./BillingTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports